import React, { useState, useEffect } from 'react'
import { Table, Input, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import axios from 'axios'
import { GetFeeApprovedList, getRoomAllocationList } from '../../../AllAPI/AdminAPI'
import { toast } from 'react-toastify'
import * as XLSX from 'xlsx'

const RoomAllotmentList = () => {
  const storedBranchId = sessionStorage.getItem('branch_id')
  const BoardingYear = sessionStorage.getItem('BoardingYear')

  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchRoomApprovedList()
  }, [])

  const fetchRoomApprovedList = async () => {
    setLoading(true)
    try {
      const res = await axios.get(
        `${getRoomAllocationList}/${storedBranchId}/${BoardingYear}`,
      )

      const formatted = res.data.map((item, index) => ({
        key: item.reg_id,
        index: index + 1,
        full_name: `${item.s_fname} ${item.s_mname} ${item.s_lname}`,
        wh_mobile: item.wh_mobile || '-',
        class_name: item.roombooking.class.class_name || '-',
        room: item.roombooking.room.room_no || '-',
        bed: item.roombooking.bed.bed_no || '-',

        full_data: item,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load approved list')
    } finally {
      setLoading(false) // 👉 Stop loader
    }
  }

  // --- SEARCH ---
  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    return (item.full_name ?? '').toLowerCase().includes(search)
  })

  const columns = [
    { title: 'Sr No', dataIndex: 'index', width: 80 },
    { title: 'Full Name', dataIndex: 'full_name' },
    { title: "What's App No.", dataIndex: 'wh_mobile' },
    { title: 'Building', dataIndex: 'class_name' },
    { title: 'Room', dataIndex: 'room' },
    { title: 'Bed', dataIndex: 'bed' },
  ]

  const exportToExcel = () => {
    if (filteredData.length === 0) {
      toast.warning('No data available to export')
      return
    }

    const excelData = filteredData.map((item, index) => ({
      'Sr No': index + 1,
      'Student Name': item.full_name,
      'WhatsApp No': item.wh_mobile,
      'Building': item.class_name,
      'Room': item.room,
      'Bed': item.bed,
    }))

    const worksheet = XLSX.utils.json_to_sheet(excelData)

    worksheet['!cols'] = [
      { wch: 8 },
      { wch: 35 },
      { wch: 18 },
      { wch: 12 },
      { wch: 12 },
    ]

    const workbook = XLSX.utils.book_new()

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Room Allotment')

    XLSX.writeFile(workbook, 'Room_Allotment_List.xlsx')
  }

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Room Allotment List</h2>
          </div>

          <div
            className="d-flex justify-content-between align-items-center mb-3 flex-wrap"
            style={{ gap: '10px' }}
          >
            <Button
              type="primary"
              onClick={exportToExcel}
              style={{
                backgroundColor: '#198754',
                borderColor: '#198754',
              }}
            >
              Export Excel
            </Button>

            <Input
              placeholder="Search..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
            className="shadow border rounded"
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>
    </div>
  )
}

export default RoomAllotmentList
